import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { auth } from "../lib/api";

// Handles the return from Google sign-in (#session_id=...) and drops the player back on the page they came from.
const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    auth
      .google(sid)
      .then(({ user, is_new, unlocked }) => {
        localStorage.setItem("fc_dev_unpin", "1");
        if (is_new && !unlocked) localStorage.setItem("fc_welcome", String(user.coins ?? ""));
        navigate(`${location.pathname}${location.search}`, { replace: true });
      })
      .catch((e) => setError(e?.response?.data?.detail || "Google sign-in failed"));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="bg-app min-h-screen flex items-center justify-center text-white" data-testid="auth-callback">
      {error ? (
        <div className="text-center">
          <p className="text-[#EF4444] font-semibold" data-testid="auth-callback-error">{error}</p>
          <button onClick={() => navigate(location.pathname, { replace: true })} className="mt-3 underline text-sm text-slate-300">Back</button>
        </div>
      ) : (
        <Loader2 className="w-7 h-7 animate-spin text-[#10B981]" />
      )}
    </div>
  );
};

export default AuthCallback;
